import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
  Modal,
  ModalVariants,
} from "@hid-galaxy-ui/galaxy-react";
import { PartnerDetailType } from "../../../../../../redux/slices/partner-details/Types";
import { useAppDispatch, useAppSelector } from "../../../../../../redux";
import {
  getPartnerDetailsSagaAction,
  updatePartnerSagaAction,
} from "../../../../../../redux/saga/partner-details/saga-actions";
import "./ToggleStatusModal.scss";

const ToggleStatusModal: React.FC<{
  partnerDetails: PartnerDetailType;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ partnerDetails, setModalOpen }) => {
  const [reason, setReason] = React.useState<string>("");
  const [submitted, setSubmitted] = React.useState<boolean>(false);
  const { status } = useAppSelector((state) => state.partner_details);
  const dispatch = useAppDispatch();
  const headerMessage =
    partnerDetails.status === "Inactive"
      ? "Please confirm that you want to enable this partner"
      : "Please confirm that you want to disable this partner";
  const inputLabel =
    partnerDetails.status === "Inactive"
      ? "Reason for enabling"
      : "Reason for disabling";
  const buttonLabel =
    partnerDetails.status === "Inactive"
      ? "Confirm and Enable Partner"
      : "Confirm and Disable Partner";
  const statusMessage =
    partnerDetails.status === "Inactive"
      ? "Partner Enabled"
      : "Partner Disabled";

  const onConfirmButtonClick = () => {
    setSubmitted(true);
    const updatedPartnerDetails = {
      ...partnerDetails,
      partner_type: partnerDetails.partner_type.join(","),
      status: partnerDetails.status === "Inactive" ? "Lapsed" : "Inactive",
      togglePartnerStatus: true,
    };
    dispatch(updatePartnerSagaAction(updatedPartnerDetails));
  };

  const footerConfig = submitted
    ? {}
    : {
        secondaryBtnLabel: "Cancel",
      };

  const onModalClose = () => {
    setModalOpen(false);
    if (submitted && status.updatePartnerStatus)
      dispatch(getPartnerDetailsSagaAction(partnerDetails.ID));
  };

  return (
    <Modal
      headerText="Confirmation"
      size={ModalVariants.Medium}
      footerConfig={footerConfig}
      onClose={() => onModalClose()}
      className="toggle-status-modal"
    >
      {submitted ? (
        <div className="status-message-modal-container">
          {status.updatePartnerLoading ? (
            <Loader variant={LoaderSizes.large} />
          ) : status.updatePartnerStatus ? (
            <>
              <Iconography
                icon="circleCheck"
                size={IconographySizes.XLarge}
                theme={IconographyThemes.Success}
              />
              <div className="message">{statusMessage}</div>
              <Button
                variant="primary"
                label="Continue"
                onClick={() => onModalClose()}
              />
            </>
          ) : (
            <>
              <Iconography
                icon="circleXmark"
                size={IconographySizes.XLarge}
                theme={IconographyThemes.Error}
              />
              <div className="message">Something went wrong</div>
              <Button
                variant="primary"
                label="Continue"
                onClick={() => setModalOpen(false)}
              />
            </>
          )}
        </div>
      ) : (
        <div className="message-button-container">
          <p className="confirm-message">{headerMessage}</p>
          <div className="icon-wrapper">
            <Iconography icon="buildings" size={IconographySizes.Medium} />
          </div>
          <div className="name">{partnerDetails.partner_name}</div>
          <div className="status">{`${partnerDetails.status} Partner`}</div>
          {/* <TextField
            id="reason"
            name="reason"
            label={inputLabel}
            value={reason}
            placeholder="Enter here"
            theme="dark"
            onChange={(e) => setReason(e.currentTarget.value)}
          /> */}
          <Button
            variant="primary"
            label={buttonLabel}
            onClick={onConfirmButtonClick}
          />
        </div>
      )}
    </Modal>
  );
};

export default ToggleStatusModal;
